import * as Sentry from '@sentry/react';

export const SentryReportError = (
  error: any,
  context: {
    payload?: any;
    additionalContext?: Record<string, any>;
  }
) => {
  Sentry.withScope((scope) => {
    scope.setTag('location', window.location.href);
    if (typeof error === 'string') {
      scope.setExtra('Message', error);
    } else {
      if (error?.config?.url) {
        scope.setExtra('Endpoint', error.config.url);
      }
      if (error?.config?.params) {
        scope.setExtra('Params', error.config.params);
      }
      if (error?.config?.data) {
        scope.setExtra('Body', JSON.parse(error.config.data));
      }
    }
    if (context?.payload) {
      scope.setExtra('Request Payload', context.payload);
    }
    scope.setLevel('error');
    if (typeof error === 'string') {
      Sentry.captureMessage(error);
    } else {
      Sentry.captureException(error);
    }
  });
};
